/**
 * NZSC-3814 / NZSC-3816 — "잔금일 미정" 기획(노션 정본)의 내부 테스터 게이트.
 *
 * 잠그는 대상은 **이번 기획정본에 실린 변경분만**이다. 개선이든 버그픽스든 기획서에 있으면
 * 예외 없이 잠근다 — "이건 개선이니 그냥 연다" 같은 개별 판단을 넣기 시작하면 무엇이 잠겼는지
 * 아무도 말할 수 없게 된다.
 *
 * 꺼진 상태(= 일반 고객)에서는 **오늘 운영과 100% 동일**해야 한다. 신규 화면·신규 분기는
 * 하나도 보이지 않고, 기존 체크박스·기존 퍼널 순서·기존 6개월 상한이 그대로 살아 있다.
 * (KRE-160: 안심 매매 패키지 가입 퍼널 순서는 이 게이트와 무관해졌다. 꺼지면 잔금일 '아니요' 차단과 금액대 숨김만 돌아온다.)
 *
 * ── 게이트가 필요한 곳(입구) ─────────────────────────────────────────────
 *  · 매매 리포트 잔금일 입력 화면(일반/프리미엄) — 초중하순·연월휠·1년 상한·체크박스 제거
 *  · 안심 매매 패키지 가입 퍼널 — 순서 변경, '아니오' 차단 해제, 매매금액 구간 선택
 *  · 부동산 정보 변경(잔금일) — 1년 상한·연월휠
 *  · 변동 알리미 탭 타이틀
 *  · 가입 정보 수정 팝업의 보험가입금액 수정 버튼
 *
 * ── 게이트가 필요 없는 곳(데이터로 자동 분리) ──────────────────────────────
 *  띠배너·스낵바·리포트 내 잔금일 팝업·재노출 3분기·알리미 '정보 입력 필요'·계약 정보 입력
 *  화면·가입완료 화면 분기·왓슨 표기·알림톡. 전부 `balance_period_*` 또는 `sale_amount_band`
 *  가 저장돼 있어야 나타난다. 위 입구를 막으면 고객 데이터에는 그 값이 생기지 않는다.
 *
 * 서버(api-public)에도 같은 게이트가 있다. FE 게이트는 화면을 감추는 것이고, 값을 만드는
 * 것을 실제로 막는 정본은 서버다.
 *
 * ── 현재 상태: 전체 오픈 (NZSC-3939, 2026-09-08) ──────────────────────────
 * 아래 `FULL_OPEN` 이 true 라 전원 통과한다. 위 설명은 **롤백했을 때의 동작**이며 그대로
 * 유효하다 — 롤백은 `FULL_OPEN` 한 줄을 false 로 되돌리는 것이 전부다.
 * 판정 로직을 지우지 않고 팩토리로 남겨 둔 이유가 이것이고, 스펙도 열림·닫힘 두 상태를
 * 모두 계속 지킨다(loan-relay `fnCreateLoanRelayChatAccessChecker` 와 같은 구조).
 */

import { isTestPaymentApiHost } from "@/utils/testPaymentAccess";

/**
 * 잔금일 미정 기획의 신규 시나리오를 노출해도 되는지 판정한다.
 *
 * 운영에서는 내부 테스터만, 로컬·dev 에서는 전원 허용한다(오너 지시 2026-09-03:
 * "로컬은 제외하고 운영에서만").
 *
 * @param {boolean} isInternalTester userStore/isInternalTester
 * @param {string} [apiHost] VUE_APP_HOST (주입 가능 — 테스트용)
 * @returns {boolean}
 */
export function fnCreateBalanceUndecidedChecker(fullOpen) {
  return function fnIsBalanceUndecidedEnabled(
    isInternalTester,
    apiHost = process.env.VUE_APP_HOST,
  ) {
    // 전체 오픈이면 명단·호스트 판정 이전에 통과 (NZSC-3939)
    if (fullOpen === true) return true;
    // 로컬·dev 호스트는 게이트 없음 — 개발/QA 가 테스터 명단에 없어도 전 시나리오를 탄다
    if (isTestPaymentApiHost(apiHost)) return true;
    return isInternalTester === true;
  };
}

/** 전체 오픈 스위치 — 롤백은 이 한 줄만 false. */
const FULL_OPEN = true;

export const fnIsBalanceUndecidedEnabled = fnCreateBalanceUndecidedChecker(FULL_OPEN);

export default fnIsBalanceUndecidedEnabled;
